import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconTipProduct = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    ref={ref}
    width="19"
    height="24"
    viewBox="0 0 19 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="yfm-icon yfm-icon-tip-product"
    {...omit(props, ["className"])}
  >
    <path
      d="M18.7464 6.70202L15.251 3.2323C15.0983 3.07924 14.8952 2.99367 14.674 2.99367H9.63522C9.63522 2.95993 9.65205 2.92618 9.65205 2.89123C9.65205 1.29196 8.31182 0 6.66629 0C5.02075 0 3.68052 1.29316 3.68052 2.89123V2.99367H0.813753C0.37262 2.99367 0 3.35041 0 3.80958V23.1841C0 23.6264 0.355792 24 0.813753 24H18.1862C18.6274 24 19 23.6433 19 23.1841V7.28051C18.9832 7.05996 18.8978 6.85508 18.7452 6.70202H18.7464ZM5.34409 2.89123C5.34409 2.22838 5.93788 1.68364 6.65066 1.68364C7.36345 1.68364 7.95723 2.22838 7.95723 2.89123C7.95723 2.92498 7.95723 2.95872 7.97406 2.99367H5.34409V2.89123ZM17.3725 22.3851H1.62871V4.62669H3.6649V10.4947C3.6649 12.094 5.00512 13.386 6.65066 13.386C8.2962 13.386 9.63643 12.0928 9.63643 10.4947V7.12624C9.63643 6.66707 9.2626 6.27538 8.78782 6.27538C8.31303 6.27538 7.95603 6.6502 7.95603 7.10937V10.4947C7.95603 11.1576 7.36224 11.7023 6.64946 11.7023C5.93667 11.7023 5.34289 11.1576 5.34289 10.4947V4.62669H14.1824V7.28051C14.1824 7.55288 14.4024 7.77343 14.674 7.77343H17.3713V22.3851H17.3725Z"
      fill="#17215C"
    />
  </svg>
));

IconTipProduct.displayName = "IconTipProduct";

export default IconTipProduct;
